import { render } from "./WhySogdoItsWhatWeDoComp.vue?vue&type=template&id=fd7098bc&scoped=true"
import script from "./WhySogdoItsWhatWeDoComp.vue?vue&type=script&lang=js"
export * from "./WhySogdoItsWhatWeDoComp.vue?vue&type=script&lang=js"

import "./WhySogdoItsWhatWeDoComp.vue?vue&type=style&index=0&id=fd7098bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd7098bc"]])

export default __exports__